import AETDatatable from "./contents/AETDatatable/AETDatable";
import AETChart from "./contents/AETChart/AETChart";
import AETSummary from "./contents/AETSummary/AETSummary";
import { useState } from "react";

const AETDashboard = () => {
    const [loadSummary, setLoadSummary] = useState(true);
  return (
    <div className="animated fadeIn">
      <AETChart />
      <AETSummary loadSummary={loadSummary} setLoadSummary={setLoadSummary} />
      <AETDatatable setLoadSummary={setLoadSummary} />
    </div>
  );
};

export default AETDashboard;
